// React import removed as it is not used directly
import { Toaster } from 'sonner';
import SuperAdminDashboard from '../components/SuperAdminDashboard';

interface SuperAdminPortalProps {
    user: any;
    onLogout: () => void;
}

export default function SuperAdminPortal({ user, onLogout }: SuperAdminPortalProps) {
    return (
        <>
            <Toaster position="top-right" />
            <SuperAdminDashboard user={user} onLogout={onLogout} />
        </>
    );
}
